const UNAUTH_ALLOWED_PAGES = [
  "/signin",
  "/signup",
  "/wealth-signup",
  "/forgot-password",
  "/academic-signup",
  "/verify-academic-signup",
];

const PUBLIC_ALLOWED_PAGES = [
  "^/company/[^/]+$", // matches /company/something but not /company/something/tab
  "^/investor/[^/]+$",
  "^/robots.txt$",
  "^/api/.*$",
];

const AUTH_ALLOWED_PAGES = [
  "^/$",
  "^/search(/.*)?$",
  "^/company/[^/]+/[^/]+$",
  "^/account$",
  "^/upgrade$",
  "^/watchlists(/.*)?$",
];

export const isPrivatePage = (pathname: string): boolean =>
  AUTH_ALLOWED_PAGES.some((pattern) => new RegExp(pattern).test(pathname));

export const isUnauthenticatedRoute = (pathname: string): boolean =>
  UNAUTH_ALLOWED_PAGES.some((route) => route === pathname);

export const isPublicRoute = (pathname: string): boolean =>
  PUBLIC_ALLOWED_PAGES.some((pattern) => new RegExp(pattern).test(pathname));

export const isPrivateCompanyTab = (pathname: string): boolean =>
  /^\/company\/.+?\/(funding|financials|deals|signals)$/.test(pathname);

export const shouldRedirectToUpgrade = (
  pathname: string,
  isFreeUser: boolean
): boolean => {
  if (!isFreeUser || pathname === "/upgrade") {
    return false;
  }

  return !isPublicRoute(pathname) || isPrivateCompanyTab(pathname);
};

export const shouldRedirectFromWatchlist = (
  pathname: string,
  hasDirectAccess: boolean
): boolean => hasDirectAccess && pathname.startsWith("/watchlists");
